<template>
	<div class="initialize-body">
		<div class="fx-header">
			<p :class="chooseType === 1 ? 'selected' : ''" @click="changeType(1)">系统初始化</p><p :class="chooseType === 2 ? 'selected' : ''" @click="changeType(2)">历史记录</p>
		</div>
		<div class="initialize-container">
			<div v-show="chooseType === 1">
				<div>
					<el-radio v-model="radio1" :label="0" border class='initialize-radio'>
						<div class="initialize-title">单据初始化</div>
						<div class="initialize-detail">* 初始化系统内所有单据，包含出入库单、订单、退单类单据、以及报表。<span @click.prevent="orderLook">查看详情</span></div>
					</el-radio>
					<el-radio v-model="radio1" :label="1" border class='initialize-radio'>
						<div class="initialize-title">商品、客户、单据初始化</div>
						<div class="initialize-detail">* 非设置项和部分数据会保留，其余数据均会清除。<span @click.prevent="productLook">查看详情</span></div>
					</el-radio>
					<el-radio v-model="radio1" :label="2" border class='initialize-radio'>
						<div class="initialize-title">系统初始化</div>
						<div class="initialize-detail">* 系统全部执行初始化（包括系统设置）。</div>
					</el-radio>
					<div style="text-align:left">
						<el-button type="primary" size='small' class="fx-big-btn" :disabled="!AuthorityList['06_0006_0001_00']" @click="initializeHandle">立即初始化</el-button>
					</div>
				</div>
			</div>
			<div v-show="chooseType === 2">
				<div class="history-table">
					<el-table
						class="grid-content"
						:data="tableData"
						max-height="600"
						border
					>
						<el-table-column
							prop="userName"
							label="操作者"
							align="center">
						</el-table-column>
						<el-table-column
							prop="createDate"
							label="操作日期"
							align="center">
						</el-table-column>
						<el-table-column
							prop="operatorTime"
							label="操作响应时间(秒)"
							align="center">
							<template slot-scope="scope">
								<div>{{scope.row.operatorTime/1000}}</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="successFlag"
							label="操作状态"
							align="center">
							<template slot-scope="scope">
								<div class="history-status" v-if="scope.row.successFlag === 1"><span></span>成功</div>
								<div class="history-status" v-else><span style="background:#ED4F31"></span>失败</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="operatorDetail"
							label="操作项目"
							align="center">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<el-dialog title="单据初始化" class="dialog-title" :visible.sync="orderModal" width='327px' :close-on-click-modal="false">
			<div>1、所有状态订单</div><div>2、所有状态退单</div><div>3、售后记录</div>
			<div>4、出入库单</div><div>5、单据消息推送</div><div>6、提成统计</div>
			<div class="initialize-foot">
				<el-button class="btn" plain type="primary" size='small' @click="orderClose">取消</el-button>
				<el-button class="btn" type="primary" size='small' @click="orderClose">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="商品、客户、单据初始化" class="dialog-title" :visible.sync="productModal" width='327px' :close-on-click-modal="false">
			<div>1、商品档案</div><div>2、客户档案</div><div>3、所有状态订单</div>
			<div>4、所有状态退单</div><div>5、售后记录</div><div>6、出入库单</div><div>7、单据消息推送</div>
			<div>8、提成统计</div><div>9、提成设置</div><div>10、返佣统计</div>
			<div class="initialize-foot">
				<el-button class="btn" plain type="primary" size='small' @click="productClose">取消</el-button>
				<el-button class="btn" type="primary" size='small' @click="productClose">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'initialize',
	data () {
		return {
			// defaultcustomerdisabledflag: null,
			// activeNames: ['1', '2'],
			// registFlag: '',
			// showInventoryFlag: null,
			// defaultImgShowType: null,
			AuthorityList: {
				'06_0006_0001_00': false
			},
			chooseType: 1,
			radio1: 0,
			orderModal: false,
			productModal: false,
			tableData: [],
			entname: '',
			shopname: '',
			timer: null,
			time: 10000
		}
	},
	created () {
		this.getAuthority('06_0006_0000_00')
		// this.getAllFlag()
		this.getName()
		this.getHistory()
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		orderLook () {
			this.orderModal = true
		},
		productLook () {
			this.productModal = true
		},
		changeType (type) {
			this.chooseType = type
		},
		orderClose () {
			this.orderModal = false
		},
		productClose () {
			this.productModal = false
		},
		// loop () {
		// 	this.timer = setTimeout(() => {
		// 		this.check()
		// 		this.loop()
		// 	}, this.time)
		// },
		// check () {
		// 	this.$store.dispatch('requestPost', {
		// 		url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/checkInitEnd`
		// 	}).then(res => {
		// 		if (res.result) {
		// 			clearInterval(this.timer)
		// 			this.timer = null
		// 			this.getHistory()
		// 			this.$message.closeAll()
		// 			this.$alert('请去历史记录中查询初始化结果', '', {
		// 				confirmButtonText: '确定',
		// 				callback: action => {
		// 					this.changeType(2)
		// 				}
		// 			})
		// 		} else {
		// 			this.$message.closeAll()
		// 			this.$message({
		// 				message: res.msg,
		// 				duration: 0,
		// 				type: 'info'
		// 			})
		// 		}
		// 	})
		// },
		initializeHandle () {
			let arr = ['单据', '商品、客户、单据', '系统']
			let arr1 = ['orderInit', 'productInit', 'systemInit']
			this.$confirm('【' + this.entname + '】-【' + this.shopname + '】是否要执行【' + arr[this.radio1] + '】初始化，在系统初始化期间，所有账号将退出登录且无法登录直到初始化完成，期间所有极速订系统中的业务将无法进行，包括门店订货、卖家发货等，需谨慎操作。', '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				// this.loop()
				// this.$message({
				// 	message: '初始化中',
				// 	duration: 0,
				// 	type: 'info'
				// })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/${arr1[this.radio1]}`,
					loading: false
				}).then(res => {
					// if (res.result) {
					// 	clearInterval(this.timer)
					// 	this.timer = null
					// 	this.$message.closeAll()
					// 	this.tipsHandle(res.msg, 'success', 1500)
					// 	this.getHistory()
					// } else {
					// 	clearInterval(this.timer)
					// 	this.timer = null
					// 	this.$message.closeAll()
					// 	this.tipsHandle(res.msg, 'error', 1500)
					// }
					window.sessionStorage.removeItem('organid')
					window.sessionStorage.removeItem('shiroSession')
				})
				this.$router.push({
					path: `/login`
				})
				// this.$store.dispatch('requestPost', {
				// 	url: `${this.$fxBaseApi.urlNVA}/logout`,
				// 	loading: false
				// }).then(res => {
				// })
			}).catch(() => {
			})
		},
		getName () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findShopBySyscode`
			}).then(res => {
				if (res.result) {
					this.entname = res.data.entname
					this.shopname = res.data.name
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		getHistory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findInitLog`
			}).then(res => {
				if (res.result) {
					// this.tipsHandle(res.msg, 'success', 1500)
					this.tableData = res.data
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		tipsHandle (content, type, duration) {
			this.$message({
				message: content,
				type: type,
				duration: duration
			})
		}
	},
	beforeDestroy () {
		clearInterval(this.timer)
		this.timer = null
	}
}
</script>

<style lang="stylus" scoped>
.initialize-body {
	display: flex;
	flex-direction: column;
	padding-left: 30px;
	.fx-header {
		p {
			cursor: pointer;
			margin-right: 30px;
			border-bottom: 0
			&.selected {
				border-bottom: 3px solid var(--fx-primary-color);
			}
		}
	}
	.initialize-container {
		.el-radio.is-bordered.initialize-radio {
			display: flex;
			width: 600px;
			height: 80px;
			margin-top: 20px;
		}
		.el-radio.is-bordered+.el-radio.is-bordered {
			margin-left: 0
		}
		.initialize-title {
			color: #333;
			text-align: left;
			font-size: 15px;
		}
		.el-radio.is-bordered.is-checked {
			color: #F8FBFF
		}
		.initialize-detail {
			color: #606266;
			text-align: left;
			font-size: 14px;
			margin-top: 20px
			span {
				color: var(--fx-primary-color);
				margin-left: 15px;
				text-decoration: underline;
			}
		}
		.fx-big-btn {
			margin: 58px 0 0 196px
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
		.el-dialog__body {
			div:not(.initialize-foot) {
				padding-left: 20px;
				margin-bottom: 15px;
				color: #333;
			}
		}
		.initialize-foot {
			text-align: right;
			margin-top: 50px;
		}
	}
	.history-table {
		width: 800px;
		margin-top: 20px;
	}
	.history-status {
		display: flex;
		justify-content: center;
		align-items: center;
		span {
			display: inline-block;
			width: 6px;
			height: 6px;
			background: #60C769;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
}
</style>
<style lang="stylus">
.initialize-body .dialog-title .el-dialog__body {
	padding: 18px 20px;
}
</style>
